export default "__VITE_ASSET__U1JkBR9c__"